module.exports = __webpack_public_path__ + "img/itemBg.410e2336.png";